export default "__VITE_ASSET__BYRqbgul__"